module.exports = __webpack_public_path__ + "media/images/cleaning/card-desktop@3x-dc858bbe526381399a27a98ce8f6935e.jpg";